import React, { useState } from "react";
import LastSynced from "../../../layout/LastSynced";
import StyledTable from "../../../ui/styledTable";
import { Box, Dialog, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import ChargingSummary from "./ChargingSummary";
import { tableHeaderReplace } from "../../../utils/tableHeaderReplace";
import { withConnectorLabels } from "../../../utils/connectorLabel";
import StyledSearchField from "../../../ui/styledSearchField";
import Filter from "../filter";
import RightDrawer from "../../../ui/RightDrawer";
import { toast } from "react-toastify";
import { getInvoice } from "../../../services/ocppAPI";
import { useSendInvoiceMail } from "../../../hooks/mutations/useOcppMutation";
const tableHeader = [
  "Transaction ID",
  "Date",
  "Username",
  "Transaction Mode",
  "Units Consumed",
  "Location Name",
  "Duration (hh:mm:ss)",
  "Chargepoint ID",
  "Connector ID",
  "Total Amount",
  "CP Stop txn reason",
  "Closed by",
];

const newActions = ["View", "Download Invoice", "Resend Email"];

export default function AllChargingTransactions({
  data,
  updateData,
  setPageNo,
  totalCount,
  setSearchQuery,
}) {
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState("");
  const [selectedData, setSelectData] = useState();

  const { mutate: sendInvoiceEmail } = useSendInvoiceMail({
    onSuccess: () => {
      toast.success("Email sent successfully");
    },
    onError: (error) => {
      console.error(error);
      toast.error("Email not sent");
    },
  });

  const AllOcppTransactionData = tableHeaderReplace(
    withConnectorLabels(data),
    [
      "transactionId",
      "date",
      "username",
      "transactionMode",
      "unitConsumed",
      "location",
      "duration",
      "chargePointId",
      "connectorId",
      "totalAmount",
      "closureReason",
      "closeBy",
      "vehicleNum",
      "vehicleInfo",
      "currentSoc",
      "startSoc",
      "id",
      "meterStart",
      "meterStop",
      "startTime",
      "endTime",
    ],
    tableHeader
  );

  const handleClose = () => {
    setOpen(false);
  };

  const downloadInvoice = async (transactionId) => {
    try {
      const result = await getInvoice(transactionId);
      if (result?.result) {
        const linkSource = `data:application/pdf;base64,${result.result}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `Invoice_${transactionId}.pdf`;
        downloadLink.click();
      } else {
        toast.error("Failed to download invoice");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to download invoice");
    }
  };

  const tableActionClick = async (e) => {
    if (e.action === "Download Invoice") {
      await downloadInvoice(e.data["Transaction ID"]);
    }
    if (e.action === "Resend Email") {
      sendInvoiceEmail(e.data["Transaction ID"]);
    }
    if (e.action === "View") {
      setAction("view");
      setSelectData(e.data);
      setOpen(true);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
  };

  return (
    <>
      <LastSynced heading="Charging Transactions" reloadHandle={updateData}>
        <StyledSearchField
          placeholder={"Search"}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
        />
        <RightDrawer>
          <Filter onSubmited={updateData} />
        </RightDrawer>
      </LastSynced>
      <Box sx={{ p: 3 }}>
        <StyledTable
          headers={tableHeader}
          data={AllOcppTransactionData}
          actions={newActions}
          onActionClick={tableActionClick}
          setPageNo={setPageNo}
          totalCount={totalCount}
        />
      </Box>

      {/* Modal */}
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <Box sx={modalStyle}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            p={2}
          >
            <Typography
              sx={{
                color: "secondary.greytext",
                fontSize: 18,
                fontWeight: 700,
              }}
            >
              Charging Summary
            </Typography>
            <Close onClick={handleClose} style={{ cursor: "pointer" }} />
          </Stack>
          <ChargingSummary datas={selectedData} />
        </Box>
      </Dialog>
    </>
  );
}

// Modal style
const modalStyle = {
  width: "auto", // Adjust width to fit your content or screen
  bgcolor: "#1D1B20", // Dark background color
  boxShadow: 10,
  color: "#fff", // White text for better visibility on dark background
  outline: "none", // Remove the focus ring
};
